const _ = require("lodash");
const Common = require("./CommonHelpers");

// Draws a '404' symbol centered at (x,y) in a cell of size cellSize with given color.
const drawSymbolNotFound = function(ctx, x, y, cellSize, color = null) {
	const padding = 0.05 * cellSize;
	const x0 = x + padding;
	const y0 = y + padding;
	const s0 = cellSize - 2 * padding;
	const w = ctx.measureText("404").width;
	ctx.save();
	ctx.translate(x0, y0);
	ctx.fillStyle = "rgb(255,192,192)";
	ctx.fillRect(0, 0, s0, s0);
	ctx.strokeStyle = "red";
	ctx.strokeRect(0, 0, s0, s0);
	ctx.fillStyle = "red";
	ctx.scale(s0 / w, s0 / w);
	ctx.textBaseline = "middle";
	ctx.textAlign = "center";
	ctx.fillText("404", w / 2, w / 2);
	ctx.restore();
};

// Draws a grid of symbols.
const drawXOGrid = function(ctx, x, y, grid, settings = {}) {
	const symbolMap = _.extend(
		{X: `$\\X[teal]$`, O: `$\\O[red]$`, " ": " "},
		settings.symbolMap
	);
	const {padding = 0, gridLines = false, border = false, scale = 1} = settings;
	const symbolNotFound = drawSymbolNotFound;
	const cellSize = parseInt(ctx.font) * 1.15;
	const gridWidth = grid.reduce(
		(total, currentValue) => Math.max(total, currentValue.length),
		0
	); // number of columns
	const gridHeight = grid.length; // number of rows
	const gridPixelWidth = gridWidth * cellSize + gridWidth * padding;
	const gridPixelHeight = gridHeight * cellSize + gridHeight * padding;
	let j = 0;
	let i = 0;

	ctx.save();
	// draw the contents of the grid
	ctx.translate(x, y);
	ctx.scale(scale, scale);
	j = 0;
	for (const row of grid) {
		i = 0;
		for (const cell of row) {
			const cellX = i * (cellSize + padding) + 0.5 * padding;
			const cellY = j * (cellSize + padding) + 0.5 * padding;
			const symbol = symbolMap[cell] || symbolNotFound;
			// if the symbol maps to a function, then call it. Otherwise, draw it as a batex string
			if (_.isFunction(symbol)) {
				symbol(ctx, cellX, cellY, cellSize, null);
			} else {
				Common.drawBatexAtCenter(
					ctx,
					symbol,
					cellX + 0.5 * cellSize,
					cellY + 0.5 * cellSize
				);
			}
			i++;
		}
		j++;
	}
	// draw border of the grid
	if (border) {
		ctx.strokeRect(0, 0, gridPixelWidth, gridPixelHeight);
	}
	// draw the inner grid lines
	if (gridLines) {
		for (j = 1; j < gridHeight; j++) {
			const lineY = j * cellSize + j * padding;
			ctx.beginPath();
			ctx.moveTo(0, lineY);
			ctx.lineTo(gridPixelWidth, lineY);
			ctx.closePath();
			ctx.stroke();
		}
		for (i = 1; i < gridWidth; i++) {
			const lineX = i * cellSize + i * padding;
			ctx.beginPath();
			ctx.moveTo(lineX, 0);
			ctx.lineTo(lineX, gridPixelHeight);
			ctx.closePath();
			ctx.stroke();
		}
	}
	ctx.restore();
};

module.exports = drawXOGrid;
